import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "global-loader"
}
const _hoisted_2 = { class: "loader-content" }
const _hoisted_3 = { class: "message" }

import { useLoaderStore } from '@/stores/loader'


export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalLoader',
  setup(__props) {

const loaderStore = useLoaderStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_unref(loaderStore).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, null, -1)),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(loaderStore).loadingMessage), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})